import { all, call, fork, put, takeEvery } from 'redux-saga/effects';


// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import moment from 'moment';

import {
  RAW_DATA_TAB_LOAD_DATA
} from 'Redux/actionTypes';

import {
  rawDataTabGetDataResult,
} from 'Redux/actions';

function hasJsonStructure(str) {
  if (typeof str !== 'string') return false;
  try {
    const result = JSON.parse(str);
    const type = Object.prototype.toString.call(result);
    return type === '[object Object]'
      || type === '[object Array]';
  } catch (err) {
    return false;
  }
}

function* getRowDataTabDataAsync({ payload }) {
  try {

    const { deviceId, method, filters } = payload;


    let ROWDATA = ""
    let data = { getEventData: [] }
    let DateFrom, DateTo, Limit, Offset
    let queryParams = {}
    //let toCloud = false;



    ROWDATA = `
        query ($conditions: [DeviceReadingSearchInput], $sort: [DeviceReadingSortInput], $limit: Int, $offset: Int){
            result: searchDeviceReadings(conditions: $conditions sort: $sort limit: $limit offset: $offset) {
              total
              items {
                accountId
                id
                deviceId
                latitude
                longitude
                heading
                eventCode
                eventName
                address
                driverId
                driverName
                ecuEngineOdometer
                ecuSpeed
                ecuEngineHours
                engineHours
                ignitionStatus
                engineOdometer
                satelliteCount
                signal
                speed
                speedLimit
                unitTime
                state
                trail
                unitType
                zip
                hDop
                vDop
                deviceData
                distance
                createdAt
                updatedAt
                direction
                duration
                formattedAddress
                landmarkId
                rawMessage
                sequenceNumber
                serverTime
                unitId
              }
            }
        }    
        `;
    console.log("filters in saga to get data:", filters)
    let dateRange = null;
    if (filters.filterByDate) {
      DateFrom = moment(filters.startDate).format("YYYY-MM-DD") + "T00:00:00-04:00";
      DateTo = moment(filters.endDate).format("YYYY-MM-DD") + "T23:59:59-04:00";
      dateRange = { start: DateFrom, end: DateTo }
      Limit = filters.rowsPeerPage;
      Offset = (filters.page - 1) * Limit;
    }

    queryParams = {
      conditions: [
        {
          fields: ["deviceId"],
          terms: [deviceId],
          exact: true,
          range: {
            fields: ["unitTime"],
            GTE: DateFrom,
            LTE: DateTo
          }
        }
      ],
      sort: {
        field: "unitTime",
        order: "DESC"
      },
      limit: Limit,
      offset: Offset
    }

    data = yield call(
      clientQuery,
      ROWDATA,
      queryParams,
      endpoints.GRAPHQL_GENERAL
    );

    let result = []



    if (data && data.result) {
      if (method === "getEventData") {
        result = data.result;
      } else if (method === "vidfleet") {
        result = JSON.parse(JSON.stringify(data.result))
        result.items.map(x => {
          if (x.deviceData && !hasJsonStructure(x.deviceData))
            x.deviceData = JSON.parse(x.deviceData);
          if (x.deviceData && hasJsonStructure(x.deviceData))
            x.deviceData = JSON.parse(x.deviceData);

        })

      } else {
        result = data.result
      }

    }
    result = JSON.parse(JSON.stringify(result))
    result.conditions = queryParams;
    yield put(rawDataTabGetDataResult(result));

  } catch (exc) {

    yield put(rawDataTabGetDataResult({ error: true }));
    ExceptionManager(exc, "modules/rawData/.components/tab/redux/saga/", "getRowDataTabDataAsync", true)
  }
}

export function* watchRawDataTabLoadData() {
  yield takeEvery(RAW_DATA_TAB_LOAD_DATA, getRowDataTabDataAsync);
}

export default function* rootSaga() {
  yield all([
    fork(watchRawDataTabLoadData)
  ]);
}